import { useQueryStates, parseAsBoolean } from 'nuqs'

export const useQueryBasedFeatureFlag = () => {
  const [value] = useQueryStates(
    {
      tierExploration: parseAsBoolean.withDefault(false),
    },
    {
      urlKeys: {
        tierExploration: 'tier-exploration',
      },
    }
  )

  return value
}
